import { Card } from '@mui/material';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NotFoundRecords from 'src/components/NotFoundRecords';
import { loadCFDIsReceived } from 'src/store/actions/cfdiActions';
import {
  selectCFDISQueryOptions,
  selectCFDIsReceivedList,
  selectCFDIsReceivedListCount
} from 'src/store/selectors/cfdiSelectors';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import { LOAD_CFDIS_RECEIVED } from 'src/store/constants/CFDI';
import CFDIReceivedTable from './CFDIReceivedTable';
import useStyles from './styles';

const CFDIReceivedList = () => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const cfdis = useSelector(selectCFDIsReceivedList);
  const count = useSelector(selectCFDIsReceivedListCount);
  const { page } = useSelector(selectCFDISQueryOptions);
  const loading = useSelector(isLoadingSelector([LOAD_CFDIS_RECEIVED.action]));
  const success = useSelector(successSelector([LOAD_CFDIS_RECEIVED.action]));

  const handleChangePage = useCallback(
    (event, value) => {
      dispatch(loadCFDIsReceived({ page: value }));
    },
    [dispatch]
  );

  if (success && !loading && count === 0) {
    return (
      <Card className={classes.prealoderCard}>
        <NotFoundRecords
          title="NOT_FOUND_RECORDS_MESSAGE.CFDI_RECEIVED_TITLE"
          description="NOT_FOUND_RECORDS_MESSAGE.CFDI_RECEIVED_DESCRIPTION"
        />
      </Card>
    );
  }

  return (
    <CFDIReceivedTable
      cfdis={cfdis}
      count={count}
      page={page}
      handleChangePage={handleChangePage}
      loading={loading}
    />
  );
};

export default CFDIReceivedList;
